import { AtlasFactory } from '../mu-atlas/interfaces/mu-atlas-factory.interface';
import {
  AtlasBounds,
  AtlasIconOptions,
  AtlasLabel,
  AtlasLabelOptions,
  AtlasMarkerOptions,
  AtlasPolygonOptions,
  AtlasPopup,
  AtlasPopupOptions,
  AtlasPosition,
} from '../mu-atlas/interfaces/mu-atlas-types.interface';
import { MuMapLeafletBounds } from './classes/mu-map-leaflet-bounds.class';
import { AtlasMarker } from '../mu-atlas/interfaces/mu-atlas-marker.interface';
import { MuMapLeafletMarker } from './classes/mu-map-leaflet-marker.class';
import { MuMapLeafletIcon } from './classes/mu-map-leaflet-icon.class';
import { MuMapLeafletLabel } from './classes/mu-map-leaflet-label.class';
import { AtlasPolygon } from '../mu-atlas/interfaces/mu-atlas-polygon.interface';
import { MuMapLeafletPolygon } from './classes/mu-map-leaflet-polygon.class';
import { MuMapLeafletPopup } from './classes/mu-map-leaflet-popup.class';

export class MuMapLeafletFactory implements AtlasFactory {
  createBoundsInstance(position?: AtlasPosition): AtlasBounds {
    return new MuMapLeafletBounds(position);
  }

  createMarkerInstance(options: AtlasMarkerOptions): AtlasMarker {
    return new MuMapLeafletMarker(options);
  }

  createPopupInstance(options: AtlasPopupOptions): AtlasPopup {
    return new MuMapLeafletPopup(options);
  }

  createIconInstance(options: AtlasIconOptions) {
    return new MuMapLeafletIcon(options);
  }

  createLabelInstance(options: AtlasLabelOptions): AtlasLabel {
    return new MuMapLeafletLabel(options);
  }

  createPolygonInstance(options: AtlasPolygonOptions): AtlasPolygon {
    return new MuMapLeafletPolygon(options);
  }
}
